<!-- ? Header con stepper de niveles -->
<ion-header mode="md" class="ion-no-border">
  <ng-container *ngIf="isLoading; else headerLoading">
    <ion-toolbar mode="md" color="getm-primary-default" class="header-loading">
      <ion-skeleton-text animated class="title-skeleton"></ion-skeleton-text>
      <ion-skeleton-text animated class="nivel-skeleton"></ion-skeleton-text>
    </ion-toolbar>
  </ng-container>

  <ng-template #headerLoading>
    <getm-levels-stepper-bar
      [promoDetail]="promoDetail"
      [niveles]="nivelesPromo"
      [level]="level"
      [isEditing]="isEditing"
      [isEditingLocked]="isEditingLocked"
      (backClick)="onBack()"
      (infoClick)="onInfo()"
      (levelClick)="onLevelClick($event)"
    ></getm-levels-stepper-bar>
  </ng-template>
</ion-header>

<!-- ? Lista de productos del nivel activo -->
<ion-content color="getm-neutral-white" [forceOverscroll]="false">
  <ion-list mode="ios" class="products-grid">
    <ng-container *ngIf="isLoading; else productsLoading">
      <ng-container *ngFor="let item of [0,1,2,3]">
        <ion-skeleton-text
          animated
          class="product-skeleton"
        ></ion-skeleton-text>
      </ng-container>
    </ng-container>

    <ng-template #productsLoading>
      <getm-promo-product-row
        [productosPromocion]="productosPromocion"
        [disabled]="disabledDinamico"
        (quantityChange)="onQuantityChange($event)"
      ></getm-promo-product-row>
    </ng-template>
  </ion-list>
</ion-content>

<!-- ? Barra inferior: Resumen + botón Siguiente nivel / Confirmar -->

<ion-footer mode="md">
  <ng-container *ngIf="isLoading; else bottomBarLoading">
    <ion-skeleton-text animated class="loading-skeleton"></ion-skeleton-text>
  </ng-container>

  <ng-template #bottomBarLoading>
    <getm-promo-bottom-bar
      [canConfirm]="canConfirm"
      [isLastLevel]="isLastLevel"
      [showSummary]="showSummary"
      (summaryClick)="onSummary()"
      (actionClick)="onAction()"
    ></getm-promo-bottom-bar>
  </ng-template>
</ion-footer>
